export const CORE_NODE_TYPE_COLORS = {
    attribute: "#338ECF",
    domain: "#F1C21B",
    process: "#54AAAA",
    state: "#D03946",
    namespace: "#955CE7",
    attribute_classification: "#E66C02",
    consumer: "#18762C",
};

// Previously used for non-core node types (kept to preserve existing UI palette).
export const DYNAMIC_TYPE_COLOR_PALETTE = [
    "#0F2C6B",
    "#7F3B01",
    "#E8416D",
    "#B0D3EC",
    "#AB8A13",
];
